// components/CreatorCard.js
import React, { useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import img from '../../assets/profiledefaultimg.webp';
import './AllCreators.css';

export const CreatorCard = ({
  creator,
  isAuthenticated,
  onSubscribe,
  onUnsubscribe,
  loading
}) => {
  const navigate = useNavigate();
  const [imgLoaded, setImgLoaded] = useState(false);

  const handleAction = () => {
    if (!isAuthenticated) {
      navigate('/signin');
      return;
    }

    if (creator.isSubscribed) {
      onUnsubscribe(creator._id);
    } else {
      onSubscribe(creator._id);
    }
  };

  return (
    <div className="creator-card-for-home">
      <div className="creator-img-container">
        <div className="creator-img-wrapper">
          {!imgLoaded && (
            <div className="img-loader">
              <Spinner animation="border" size="sm" />
            </div>
          )}
          <img
            src={creator.imagepath || img}
            alt={creator.name}
            className="creator-img"
            loading="lazy"
            style={{ visibility: imgLoaded ? 'visible' : 'hidden' }}
            onLoad={() => setImgLoaded(true)}
            onError={(e) => {
              e.target.src = img;
              setImgLoaded(true);
            }}
          />
        </div>

        <div className="creator-badge">
          {creator.subscribers?.length || 0} Subscribers
        </div>
      </div>
      <div className="creator-info">
        <h3 className="creator-name">{creator.name}</h3>
        <div className="creator-subjects">
          {creator.subjects?.slice(0, 2).map((subject, i) => (
            <span key={i} className="subject-tag">{subject}</span>
          ))}
          {creator.subjects?.length > 2 && (
            <span className="subject-tag">+{creator.subjects.length - 2}</span>
          )}
        </div>
        <div className="creator-actions">
          <Button
            style={{
              backgroundColor: creator.isSubscribed ? '#ff4d4d' : '#4caf50', // Custom colors
              borderColor: creator.isSubscribed ? '#ff4d4d' : '#4caf50',
              color: '#fff',
            }}
            onClick={handleAction}
            disabled={loading[creator._id]}
            className="action-btn"
          >
            {loading[creator._id] ? (
              <Spinner animation="border" size="sm" />
            ) : (
              creator.isSubscribed ? 'Unsubscribe' : (isAuthenticated ? 'Subscribe +' : 'Join to Follow')
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};